/* import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";

const Login = ({ onUserLogin }) => {
  const [nombre, setNombre] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useRef(null);

  const validateForm = () => {
    if (!nombre.trim()) return "El nombre es requerido";
    if (password.length < 6)
      return "La contraseña debe tener al menos 6 caracteres";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();

    if (validationError) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: validationError,
        life: 3000,
      });
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL_DEV}:${process.env.REACT_APP_API_PORT}/api/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            nombre: nombre.trim(),
            password: password,
          }),
        }
      );

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Error de autenticación");
      }

      const data = await response.json();
      localStorage.setItem("token", data.token);
      console.log(data);
      onUserLogin(data.user);
      navigate("/", { replace: true });
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        life: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Toast ref={toast} />
      <h2>Iniciar Sesión</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="form-group">
          <label htmlFor="nombre">Nombre:</label>
          <input
            id="nombre"
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            autoFocus
            required
            className="p-inputtext"
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Contraseña:</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="p-inputtext"
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className={`p-button ${isLoading ? "p-disabled" : ""}`}
          style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {isLoading ? (
            <i className="pi pi-spinner pi-spin"></i>
          ) : (
            "Iniciar Sesión"
          )}
        </button>
      </form>
    </div>
  );
};

export default Login;
 */

/* import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";

const Login = ({ onUserLogin }) => {
  const [nombre, setNombre] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useRef(null);

  const validateForm = () => {
    if (!nombre.trim()) return "El nombre es requerido";
    if (password.length < 6)
      return "La contraseña debe tener al menos 6 caracteres";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();

    if (validationError) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: validationError,
        life: 3000,
      });
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL_DEV}:${process.env.REACT_APP_API_PORT}/api/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            nombre: nombre.trim(),
            password: password,
          }),
        }
      );

      if (!response.ok) {
        const data = await response.json();
        console.log(data);
        throw new Error(data.message || "Error de autenticación");
      }
      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token);
        navigate(location.state?.from?.pathname || "/clientes", {
          replace: true,
        });
      }

      const data = await response.json();
      localStorage.setItem("token", data.token);
      navigate("/", { replace: true });
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        life: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Toast ref={toast} />
      <h2>Iniciar Sesión</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="form-group">
          <label htmlFor="nombre">Nombre:</label>
          <input
            id="nombre"
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            autoFocus
            required
            className="p-inputtext"
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Contraseña:</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="p-inputtext"
          />
          <i className="toggle-password fa fa-eye" onClick={togglePassword}></i>
          <i className={`pi pi-eye${showPassword ? "-slash" : ""}`}></i>
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className={`p-button ${isLoading ? "p-disabled" : ""}`}
          style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {isLoading ? (
            <i className="pi pi-spinner pi-spin"></i>
          ) : (
            "Iniciar Sesión"
          )}
        </button>
      </form>
    </div>
  );
};

export default Login;
 */

import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Toast } from "primereact/toast";
import { API_URL } from "../Componentes/fetchWithAuth";
import "../styles/Login.css"; // [EXPERT_COMMENT]: Importación del nuevo estilo minimalista.

const Login = ({ onUserLogin }) => {
  const [nombre, setNombre] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useRef(null);

  const validateForm = () => {
    if (!nombre.trim()) return "El nombre es requerido";
    if (password.length < 5)
      return "La contraseña debe tener al menos 5 caracteres";
    return null;
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();

    if (validationError) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: validationError,
        life: 3000,
      });
      return;
    }

    setIsLoading(true);

    try {
      if (!API_URL || API_URL === "undefined") {
        throw new Error("La URL de la API no está configurada correctamente.");
      }

      const response = await fetch(`${API_URL}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          nombre: nombre.trim(),
          password: password,
        }),
      });

      const contentType = response.headers.get("content-type");
      let data;

      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        const textData = await response.text();
        console.error("Respuesta no-JSON recibida:", textData);
        throw new Error(`El servidor respondió con un formato inesperado (${response.status}). Revisa la consola para más detalles.`);
      }

      if (!response.ok) {
        throw new Error(data.message || data.error || "Error de autenticación");
      }

      if (!data.token) {
        throw new Error("No se recibió token de autenticación");
      }

      if (data.usuario && data.usuario.rol === "Bodega") {
        toast.current.show({
          severity: "error",
          summary: "Acceso Denegado",
          detail: "No tienes los privilegios suficientes para acceder.",
          life: 5000,
        });
        localStorage.removeItem("token");
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("lastActivity", Date.now().toString());

      if (onUserLogin) {
        onUserLogin(data.usuario || { nombre: nombre.trim() });
      }

      const redirectPath = location.state?.from?.pathname || "/listapedidos";
      navigate(redirectPath, { replace: true });
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        life: 3000,
      });
      localStorage.removeItem("token");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <Toast ref={toast} position="top-center" />
      <div className="login-card">
        <h2>Iniciar Sesión</h2>
        <form onSubmit={handleSubmit} className="login-form-minimal">
          <input
            id="login-input-nombre"
            type="text"
            placeholder="Usuario"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            autoFocus
            required
            className="login-input-minimal"
          />

          <div className="password-wrapper">
            <input
              id="login-input-password"
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="login-input-minimal"
              autoComplete="current-password"
            />
            <i
              id="login-toggle-password"
              className={`toggle-password-minimal pi pi-eye${showPassword ? "-slash" : ""}`}
              onClick={togglePassword}
            ></i>
          </div>

          <button
            id="btn-login-iniciar"
            type="submit"
            disabled={isLoading}
            className="btn-login-minimal"
          >
            {isLoading ? (
              <i className="pi pi-spinner pi-spin"></i>
            ) : (
              <i className="pi pi-sign-in"></i>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
